module.exports = __webpack_public_path__ + "static/gallery22-936aa9bc1cab808d3bbeffddd3b99339.jpg";